import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions";
import {ApolloQueryObservable} from "apollo-angular";
import {SensorService} from "../../services/sensor.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'vb-sensor-dashboard-view',
  templateUrl: './sensor-dashboard-view.component.html',
  styleUrls: ['./sensor-dashboard-view.component.css']
})
export class SensorDashboardViewComponent extends AbstractVisbosComponent implements OnInit {

  private sensors$: ApolloQueryObservable<any>;
  public sensors: any;

  loadingIndicator: boolean = true;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private sensorService: SensorService,
              private router: Router, private route: ActivatedRoute) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.sensors$ = this.sensorService.getSensors();
    this.addComponentData(this.sensors$);
    this.addSubscription(this.sensors$.subscribe(res => {
      this.loadingIndicator = res.loading;
      this.sensors = res.data.sensors;
    }));

  }

  getSensorColorClass(sensor) {
    return {
      'panel-success': sensor.latest_value && !sensor.latest_value.is_critical,
      'panel-danger': sensor.latest_value && sensor.latest_value.is_critical
    }
  }

  onSensorDetailsClicked(sensor) {
    this.router.navigate(['../auswertung', sensor.cuid], {relativeTo: this.route});
  }

}



// WEBPACK FOOTER //
// ./src/app/sensors/views/sensor-dashboard-view/sensor-dashboard-view.component.ts